import { gql } from '@apollo/client';

export const BATCH_SAVE_ADDRESSES = gql`
  mutation BatchSaveAddresses($addressStrings: [String!]!) {
    batchSaveAddresses(addressStrings: $addressStrings) {
      results {
        originalAddress
        fullStandardAddress
        errorMessage
      }
      successCount
      failedCount
      totalCount
    }
  }
`;

export interface BatchSaveAddressesResponse {
  batchSaveAddresses: {
    results: {
      originalAddress: string;
      fullStandardAddress?: string | null;
      errorMessage?: string | null;
    }[];
    successCount: number;
    failedCount: number;
    totalCount: number;
  };
}

